export default __webpack_public_path__ + "static/media/connectwise-long.129889ab.svg";